import { breakpoint, debounce } from '../../util/helpers';
import { setElementInert, setParentInert } from '../../util/a11y/handle-inert';

export default {
  init() {
    if (!document.querySelectorAll('.ms-dropdown__toggle').length) {
      return;
    }

    this.startListener();
  },
  startListener() {
    const selector = {
      dropdown: '.ms-dropdown',
      item: '.ms-dropdown__item',
      list: '.ms-dropdown__list',
      toggle: '.ms-dropdown__toggle',
      footerGroup: '.ms-footer__group',
      emailInput: '.ms-footer__sign-up-textfield',
      signUp: '.ms-footer__sign-up',
    };

    const dropdowns = document.querySelectorAll(selector.dropdown);
    const lists = document.querySelectorAll(selector.list);
    const toggles = document.querySelectorAll(selector.toggle);
    const emailInput = document.querySelector(selector.emailInput);
    const footerGroup = document.querySelector(selector.footerGroup);
    const signUp = document.querySelector(selector.signUp);

    if (emailInput) {
      emailInput.addEventListener('change', ({ target }) => {
        if (target.value) {
          footerGroup.classList.add('has-text');
        } else {
          footerGroup.classList.remove('has-text');
        }
      });
    }

    /* disable tabbing */
    const disableInert = list => {
      setParentInert(false, list);
    }

    /* enable tabbing */
    const enableInert = list => {
      setParentInert(true, list);
    }

    const initiateInert = () => {
      if (breakpoint() === 'mobile') {
        toggles.forEach(toggle => setElementInert(false, toggle));
        lists.forEach(list => setParentInert(true, list));
      } else {
        toggles.forEach(toggle => setElementInert(true, toggle));
        lists.forEach(list => setParentInert(false, list));
      }
    }

    const closeDropdown = toggle => {
      const { target } = toggle;
      const activeDropdown = Array.prototype.find.call(dropdowns, dropdown => dropdown.classList.contains('active'));
      const activeList = Array.prototype.find.call(lists, list => list.style.height);

      if (activeDropdown && activeList) {
        const activeToggle = activeDropdown.querySelector(selector.toggle);

        if (activeToggle !== target) {
          enableInert(activeList);

          activeDropdown.classList.remove('active');
          activeList.removeAttribute('style');
          activeToggle.setAttribute('aria-expanded', false);
        }
      }
    };

    const toggleDropdown = toggle => {
      const toggleList = toggle.nextElementSibling;
      const listItems = toggleList.querySelectorAll(selector.item);
      const activeDropdown = toggleList.closest(selector.dropdown);

      if (toggleList.style.height) {
        activeDropdown.classList.remove('active');
        toggleList.removeAttribute('style');
        toggle.setAttribute('aria-expanded', 'false');
        enableInert(toggleList);
      } else if (breakpoint() === 'mobile') {
        closeDropdown(toggle); // close the previous active dropdown
        disableInert(toggleList);

        let listItemsHeight = 0;

        listItems.forEach(listItem => {
          const listItemStyle = getComputedStyle(listItem);
          listItemsHeight = listItemsHeight + listItem.offsetHeight + parseFloat(listItemStyle.marginTop) + parseFloat(listItemStyle.marginBottom);
        });

        toggleList.style.height = `${listItemsHeight}px`;
        activeDropdown.classList.add('active');
        toggle.setAttribute('aria-expanded', 'true');
      }
    };

    const onResize = debounce((toggle) => {
      closeDropdown(toggle);
      initiateInert();
    }, 100);

    initiateInert();
    toggles.forEach(toggle => toggle.addEventListener('click', () => toggleDropdown(toggle)));
    document.addEventListener('click', closeDropdown);
    window.addEventListener('resize', onResize);

    // gravity form restructure
    const newsletterWrapper = signUp.querySelector('.gform_wrapper');
    const { dataset: { lang: submitEmailLabel } } = footerGroup;

    const newsletterForm = signUp.querySelector('form');
    if (!newsletterWrapper) return;

    const newsletterObserver = new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'childList') {
          Array.from(record.addedNodes).filter(n => n.tagName === 'FORM').forEach(form => {
            intializeNewsletterForm(form);
          })
        }
      })
    });

    const intializeNewsletterForm = (form) => {
      const newsletterFields = form.querySelectorAll('li.gfield');
      newsletterFields.forEach(newsletterField => {
        const inputField = newsletterField.querySelector('input');
        inputField.removeAttribute('tabindex');
      });

      const signUpButton = form.querySelector('.gform_footer input[type="submit"]');
      signUpButton.value = '';
      signUpButton.setAttribute('aria-label', submitEmailLabel);
      signUpButton.removeAttribute('tabindex');
    }

    intializeNewsletterForm(newsletterForm);
    newsletterObserver.observe(newsletterWrapper, { subtree: true, childList: true, attributes: true });
  },
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/footer.js